import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Envelope. The flap "opens" on mount, then settles, drawing the eye
 *  toward the inferred-kind cue without distracting the reader. The
 *  `active` prop replays the flourish (e.g. when the user just typed
 *  an `@` and we flipped from phone to email). */
export function IcnMail(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const animate = useDecorativeIconMotion(active);
  return (
    <Svg {...rest} iconName="mail" data-on={active ? 'true' : 'false'}>
      <rect x="2" y="3.5" width="12" height="9" rx="1.4" />
      {/* Static crease — the seam between the flap and the body */}
      <path d="M2 4.5l6 4 6-4" opacity="0.3" />
      {/* Animated flap — strokes in on mount; on `active` flip, replays. */}
      <path
        d="M2 4.5l6 4 6-4"
        strokeDasharray="20"
        strokeDashoffset={animate ? '20' : '0'}
      >
        {animate && (
          <animate
            key={active ? 'on' : 'off'}
            attributeName="stroke-dashoffset"
            from="20"
            to="0"
            dur="0.55s"
            fill="freeze"
          />
        )}
      </path>
    </Svg>
  );
}
